<template>
    <div class="notification-container">
        <div class="info">
            <div class="close-button"
                 @click="closeNotificationFunction">
                &times;
            </div>
            <div class="title">
                <Translate translationKey="quests-dashboard.notifications"
                           fallback="Notifications" />
            </div>
            <hr class="title-divider">
            <div v-for="notification in props.notifications"
                 :key="notification.title">
                <a :href="notification.link"
                   :target="notification.isExternal && '_blank'"
                   :rel="notification.isExternal && 'nofollow noindex noopener'"
                   data-category="menu-notification"
                   @click="closeNotificationFunction">
                    <Notification :notification="notification" />
                </a>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import Notification from '../Notification.vue';
    import { NotificationType } from '../../types/types';

    const props = defineProps<{
        notifications: NotificationType[],
        closeNotificationFunction:(payload: MouseEvent) => void,
    }>();
</script>

<style scoped lang="scss">
@use "@/sass/partials/variables" as legacyVariables;
@use "@/sass/partials/z-index" as ZIndex;
@use "@/sass/design-system/variables" as variables;

.notification-container {
    position: fixed;
    z-index: ZIndex.$navigation-modal-z-index;
    top: 0;
    right: 0;
    left: 0;
    height: 100vh;
    padding: 0 16px 16px 16px;
    background: variables.$baseWhite;

    .title-divider {
        margin-top: 0;
        margin-bottom: 8px;
    }

    .info {
        padding: 0;
        margin-right: 0;
        margin-left: 0;
    }

    .close-button {
        display: flex;
        height: 40px;
        color: legacyVariables.$body-color;
        cursor: pointer;
        font-size: 40px;
        transition: color 200ms ease;

        &:hover {
            color: variables.$baseBlack;
        }
    }

    .title {
        color: legacyVariables.$body-color;
        font-size: 19px;
        font-weight: 500;
        text-align: center;
    }

    hr {
        background: legacyVariables.$pill-color-contrast;
    }
}

.dark-theme {
    .notification-container {
        background: legacyVariables.$tippy-mobile-background;

        .title {
            color: variables.$baseWhite;
        }

        .close-button {
            color: legacyVariables.$light-grey-blue;

            &:hover {
                color: variables.$baseWhite;
            }
        }

        hr {
            background: legacyVariables.$regal-purple;
        }
    }
}
</style>
